import { useLocale } from '@/hooks/useLocale';
import useUserContext from '@/hooks/useUserContext';
import { VT_LEGACY_URL } from '@/utils/url';
import { getCookie } from 'cookies-next';
import Link from 'next/link';
import { PropsWithChildren } from 'react';

type WithAnchorProps = {
  withAnchor: boolean;
};

type WithoutAnchorProps = {
  withAnchor?: boolean;
};

type Props = PropsWithChildren & (WithAnchorProps | WithoutAnchorProps);

export default function UserAvatarContainer({ withAnchor, children }: Props) {
  const { userGrant, user } = useUserContext();
  const lang = useLocale();

  const isAdmin = userGrant && userGrant === 'admin';

  const sessionId = getCookie('sessionId');

  function getAnchorLink() {
    if (isAdmin) {
      return `${VT_LEGACY_URL}/?token=${sessionId}&url=${encodeURIComponent(
        '/admin/dashboard',
      )}`;
    }

    if (userGrant && userGrant === `owner`) {
      return `${VT_LEGACY_URL}/?token=${sessionId}&url=${encodeURIComponent(
        '/owner/dashboard',
      )}`;
    }

    return user.languageCode == `en`
      ? `${VT_LEGACY_URL}/?token=${sessionId}&url=${encodeURIComponent(
          '/customer/dashboard',
        )}`
      : `${VT_LEGACY_URL}/${lang}/?token=${sessionId}&url=${encodeURIComponent(
          '/customer/dashboard',
        )}`;
  }

  return (
    <>
      {isAdmin && (
        <span className="bg-[hsla(0,0%,100%,.8)] rounded-[5px] text-error-primary block text-[10px] h-[15px]  leading-[15px] absolute text-center top-1/2 -translate-y-1/2 w-[36px] uppercase">
          Admin
        </span>
      )}
      {withAnchor ? (
        <Link href={getAnchorLink()}>{children}</Link>
      ) : (
        <div>{children}</div>
      )}
    </>
  );
}
